import React from 'react';
import { DateRange } from 'react-day-picker';
import { StudyDateRangeFilter } from '../../table-common/filters/columnFilters';
import { FilterWrapper } from './filterWrapper';

interface DateFilterProps {
  column: any;
}

export const DateFilter: React.FC<DateFilterProps> = ({ column }) => {
  const filterValue = column.getFilterValue();

  const dateRange = React.useMemo(() => {
    if (Array.isArray(filterValue)) {
      return {
        from: filterValue[0],
        to: filterValue[1],
      };
    }
    return filterValue as DateRange | undefined;
  }, [filterValue]);

  return (
    <FilterWrapper
      filterValue={filterValue}
      onClear={() => column.setFilterValue(undefined)}
      className="w-4/4"
    >
      <StudyDateRangeFilter
        value={dateRange}
        onChange={(range) => column.setFilterValue(range)}
      />
    </FilterWrapper>
  );
};
